[
  {
    "code": "EUR",
    "label": {
      "en": "Euro",
      "es": "Euro"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "symbol": "€",
      "decimals": 2
    }
  },
  {
    "code": "USD",
    "label": {
      "en": "US Dollar",
      "es": "Dólar estadounidense"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "symbol": "$",
      "decimals": 2
    }
  },
  {
    "code": "GBP",
    "label": {
      "en": "British Pound",
      "es": "Libra esterlina"
    },
    "order": 3,
    "is_active": false,
    "metadata": {
      "symbol": "£",
      "decimals": 2
    }
  },
  {
    "code": "JPY",
    "label": {
      "en": "Japanese Yen",
      "es": "Yen japonés"
    },
    "order": 4,
    "is_active": false,
    "metadata": {
      "symbol": "¥",
      "decimals": 0
    }
  },
  {
    "code": "CNY",
    "label": {
      "en": "Chinese Yuan",
      "es": "Yuan chino"
    },
    "order": 5,
    "is_active": false,
    "metadata": {
      "symbol": "¥",
      "decimals": 2
    }
  },
  {
    "code": "CHF",
    "label": {
      "en": "Swiss Franc",
      "es": "Franco suizo"
    },
    "order": 6,
    "is_active": false,
    "metadata": {
      "symbol": "CHF",
      "decimals": 2
    }
  },
  {
    "code": "CAD",
    "label": {
      "en": "Canadian Dollar",
      "es": "Dólar canadiense"
    },
    "order": 7,
    "is_active": false,
    "metadata": {
      "symbol": "C$",
      "decimals": 2
    }
  },
  {
    "code": "AUD",
    "label": {
      "en": "Australian Dollar",
      "es": "Dólar australiano"
    },
    "order": 8,
    "is_active": false,
    "metadata": {
      "symbol": "A$",
      "decimals": 2
    }
  },
  {
    "code": "MXN",
    "label": {
      "en": "Mexican Peso",
      "es": "Peso mexicano"
    },
    "order": 9,
    "is_active": false,
    "metadata": {
      "symbol": "$",
      "decimals": 2
    }
  },
  {
    "code": "ARS",
    "label": {
      "en": "Argentine Peso",
      "es": "Peso argentino"
    },
    "order": 10,
    "is_active": false,
    "metadata": {
      "symbol": "$",
      "decimals": 2
    }
  },
  {
    "code": "BRL",
    "label": {
      "en": "Brazilian Real",
      "es": "Real brasileño"
    },
    "order": 11,
    "is_active": false,
    "metadata": {
      "symbol": "R$",
      "decimals": 2
    }
  },
  {
    "code": "COP",
    "label": {
      "en": "Colombian Peso",
      "es": "Peso colombiano"
    },
    "order": 12,
    "is_active": false,
    "metadata": {
      "symbol": "$",
      "decimals": 2
    }
  },
  {
    "code": "CLP",
    "label": {
      "en": "Chilean Peso",
      "es": "Peso chileno"
    },
    "order": 13,
    "is_active": false,
    "metadata": {
      "symbol": "$",
      "decimals": 0
    }
  },
  {
    "code": "PEN",
    "label": {
      "en": "Peruvian Sol",
      "es": "Sol peruano"
    },
    "order": 14,
    "is_active": false,
    "metadata": {
      "symbol": "S/",
      "decimals": 2
    }
  },
  {
    "code": "UYU",
    "label": {
      "en": "Uruguayan Peso",
      "es": "Peso uruguayo"
    },
    "order": 15,
    "is_active": false,
    "metadata": {
      "symbol": "$U",
      "decimals": 2
    }
  },
  {
    "code": "BOB",
    "label": {
      "en": "Bolivian Boliviano",
      "es": "Boliviano"
    },
    "order": 16,
    "is_active": false,
    "metadata": {
      "symbol": "Bs",
      "decimals": 2
    }
  },
  {
    "code": "PYG",
    "label": {
      "en": "Paraguayan Guarani",
      "es": "Guaraní paraguayo"
    },
    "order": 17,
    "is_active": false,
    "metadata": {
      "symbol": "₲",
      "decimals": 0
    }
  },
  {
    "code": "VES",
    "label": {
      "en": "Venezuelan Bolivar",
      "es": "Bolívar venezolano"
    },
    "order": 18,
    "is_active": false,
    "metadata": {
      "symbol": "Bs.S",
      "decimals": 2
    }
  },
  {
    "code": "DOP",
    "label": {
      "en": "Dominican Peso",
      "es": "Peso dominicano"
    },
    "order": 19,
    "is_active": false,
    "metadata": {
      "symbol": "RD$",
      "decimals": 2
    }
  },
  {
    "code": "CRC",
    "label": {
      "en": "Costa Rican Colon",
      "es": "Colón costarricense"
    },
    "order": 20,
    "is_active": false,
    "metadata": {
      "symbol": "₡",
      "decimals": 2
    }
  },
  {
    "code": "GTQ",
    "label": {
      "en": "Guatemalan Quetzal",
      "es": "Quetzal guatemalteco"
    },
    "order": 21,
    "is_active": false,
    "metadata": {
      "symbol": "Q",
      "decimals": 2
    }
  },
  {
    "code": "HNL",
    "label": {
      "en": "Honduran Lempira",
      "es": "Lempira hondureño"
    },
    "order": 22,
    "is_active": false,
    "metadata": {
      "symbol": "L",
      "decimals": 2
    }
  },
  {
    "code": "NIO",
    "label": {
      "en": "Nicaraguan Cordoba",
      "es": "Córdoba nicaragüense"
    },
    "order": 23,
    "is_active": false,
    "metadata": {
      "symbol": "C$",
      "decimals": 2
    }
  },
  {
    "code": "PAB",
    "label": {
      "en": "Panamanian Balboa",
      "es": "Balboa panameño"
    },
    "order": 24,
    "is_active": false,
    "metadata": {
      "symbol": "B/.",
      "decimals": 2
    }
  },
  {
    "code": "INR",
    "label": {
      "en": "Indian Rupee",
      "es": "Rupia india"
    },
    "order": 25,
    "is_active": false,
    "metadata": {
      "symbol": "₹",
      "decimals": 2
    }
  },
  {
    "code": "KRW",
    "label": {
      "en": "South Korean Won",
      "es": "Won surcoreano"
    },
    "order": 26,
    "is_active": false,
    "metadata": {
      "symbol": "₩",
      "decimals": 0
    }
  },
  {
    "code": "SEK",
    "label": {
      "en": "Swedish Krona",
      "es": "Corona sueca"
    },
    "order": 27,
    "is_active": false,
    "metadata": {
      "symbol": "kr",
      "decimals": 2
    }
  },
  {
    "code": "NOK",
    "label": {
      "en": "Norwegian Krone",
      "es": "Corona noruega"
    },
    "order": 28,
    "is_active": false,
    "metadata": {
      "symbol": "kr",
      "decimals": 2
    }
  },
  {
    "code": "DKK",
    "label": {
      "en": "Danish Krone",
      "es": "Corona danesa"
    },
    "order": 29,
    "is_active": false,
    "metadata": {
      "symbol": "kr",
      "decimals": 2
    }
  },
  {
    "code": "PLN",
    "label": {
      "en": "Polish Zloty",
      "es": "Zloty polaco"
    },
    "order": 30,
    "is_active": false,
    "metadata": {
      "symbol": "zł",
      "decimals": 2
    }
  }
]
